import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import useTheme from "@material-ui/core/styles/useTheme";
import { compose } from "recompose";
import Button from "@material-ui/core/Button";
import { isScoringGroupBundleUsedSelector } from "../../../redux/selectors";
import {
  fetchIsScoringGroupBundleInUse,
  hideModal,
  removeScoringGroupBundle,
} from "../../../redux/actions";

const RemoveScoringGroupBundleModal = ({
  scoringGroupId,
  bundleId,
  intl,
  isScoringGroupBundleUsedByCases,
  removeBundle,
  loadScoringGroupBundleUseStatus,
  closeModal,
}) => {
  const theme = useTheme();

  useEffect(() => {
    loadScoringGroupBundleUseStatus(scoringGroupId, bundleId);
  }, []);

  const onRemoveBundle = () => {
    removeBundle(scoringGroupId, bundleId);
  };

  return (
    <Grid
      container
      direction="column"
      justify="flex-start"
      alignItems="center"
      style={{
        width: "75rem",
        padding: "4rem",
        margin: "auto",
        backgroundColor: theme.palette.secondary.main,
      }}
    >
      <Grid item style={{ alignSelf: "center" }}>
        <Typography
          variant="h1"
          style={{
            color: "#fff",
            marginBottom: "25px",
          }}
        >
          {intl.formatMessage({ id: "app.groups.removeBundleModalTitle" })}
        </Typography>
      </Grid>
      {isScoringGroupBundleUsedByCases == false && (
        <Fragment>
          <Grid item style={{ alignSelf: "flex-start" }}>
            <Typography
              variant="h3"
              style={{
                color: "#fff",
              }}
              align="left"
            >
              {intl.formatMessage({ id: "app.groups.removeBundleModalText" })}
            </Typography>
          </Grid>
          <Grid item>
            <Grid container direction="row" justify="center">
              <Grid item>
                <Button
                  style={{
                    width: "150px",
                    marginTop: "40px",
                  }}
                  type="button"
                  variant="contained"
                  color="primary"
                  onClick={onRemoveBundle}
                >
                  {intl.formatMessage({
                    id: "app.groups.removeBundleButtonYes",
                  })}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  style={{
                    width: "150px",
                    marginTop: "40px",
                  }}
                  type="button"
                  variant="contained"
                  color="primary"
                  onClick={closeModal}
                >
                  {intl.formatMessage({
                    id: "app.groups.removeBundleButtonNo",
                  })}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Fragment>
      )}
      {!!isScoringGroupBundleUsedByCases && (
        <Fragment>
          <Grid item style={{ alignSelf: "flex-start" }}>
            <Typography
              variant="h3"
              style={{
                color: "#fff",
              }}
              align="left"
            >
              {intl.formatMessage({
                id: "app.groups.removeBundleModalIsUsedByCases",
              })}
            </Typography>
          </Grid>
          <Grid item style={{ alignSelf: "center" }}>
            <Button
              style={{
                width: "150px",
                marginTop: "40px",
              }}
              type="button"
              variant="contained"
              color="primary"
              onClick={closeModal}
            >
              {intl.formatMessage({ id: "app.groups.removeBundleButtonOk" })}
            </Button>
          </Grid>
        </Fragment>
      )}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  isScoringGroupBundleUsedByCases: isScoringGroupBundleUsedSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  removeBundle: (scoringGroupId, bundleId) => {
    dispatch(removeScoringGroupBundle(scoringGroupId, bundleId));
    dispatch(hideModal());
  },
  loadScoringGroupBundleUseStatus: (scoringGroupId, bundleId) =>
    dispatch(fetchIsScoringGroupBundleInUse(scoringGroupId, bundleId)),
  closeModal: () => dispatch(hideModal()),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
);

export default enhance(RemoveScoringGroupBundleModal);
